import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router";
import LoginForm from "./LoginForm";
import AdminPanel from "./AdminPanel";
import Landing from "./Landing";
import EventDetailPage from "./EventDetail";

export default function App() {
  const [token, setToken] = useState(localStorage.getItem("admin_token"));

  const logout = () => {
    localStorage.removeItem("admin_token");
    setToken(null);
  };

  return (
    <Router>
      <Routes>
        {/* Public routes can go here */}
        <Route path="/" element={<Landing />} />

        {/* Admin route */}
        <Route
          path="/admin/*"
          element={
            token ? (
              <AdminPanel token={token} logout={logout} />
            ) : (
              <LoginForm onLogin={setToken} />
            )
          }
        />

        <Route
          path="/events/:eventId"
          element={
            <EventDetailPage />
          }
        />
      </Routes>
    </Router>
  );
}
